document.addEventListener('DOMContentLoaded', function () {
  const modalTrigger = document.querySelectorAll('.language-modal_trigger');
  const modal = document.getElementById('language-modal_modal');
  const form = modal.querySelector('form');
  const select = form.querySelector('select');
  const wasModalShown = window.Helpers.Cookie.Get('language_modal');

  modal.addEventListener('modal:closed', function (e) {
    //console.log('lang modal closed', e);
    window.Helpers.Cookie.Set('language_modal', 1);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    window.Helpers.Cookie.Set('language_modal', 1);
    const userValue = select.value;
    const userOption = select.querySelector('option[value="' + userValue + '"]');
    const userOptionValue = userOption.getAttribute('data-url');
    window.location = userOptionValue;
    return false;
  });

  modalTrigger.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      console.log('lang modal trigger clicked');
      modal.show();
      return false;
    });
  });

  window.Helpers.Customer.getLocation().then(function (country) {
    const userCountryHandle = country.country.handle;
    //console.log('user country', country, userCountryHandle);
    const userCountryOption = document.querySelector(
      `#language-form option[data-country="${userCountryHandle.toLowerCase()}"]`,
    );
    if (userCountryOption) {
      if (userCountryOption.getAttribute('data-url').indexOf(window.location.host) > -1) {
        //console.log('user is in preferred country');
      } else {
        //console.log('user is not in preferred country');
        select.value = userCountryOption.value;
        if (modal && !wasModalShown) {
          window.Helpers.Cookie.Set('language_modal', 1);
          modal.show();
        }
      }
    }
  });
});
